import type { TFEmptyStateMessageProps } from '@tf/ui';
import { Button, Center, Icon, TFCard, TFEmptyStateMessage } from '@tf/ui';
import { useEffect } from 'react';

type TFErrorTemplateProps = {
	errorMessage?: TFEmptyStateMessageProps;
	// Function to report error to Sentry; will be called on mount
	trackErrorFn?: () => void;
};

const defaultErrorMessage: TFEmptyStateMessageProps = {
	icon: <Icon.IconUnlink />,
	title: 'Something went wrong',
	description: 'We’re already working on it. Refresh the page or come back later.',
	primaryAction: (
		<Button
			leftSection={<Icon.IconMail size={24} />}
			component="a"
			variant="light"
			size="md"
			href="mailto:support@trustform.io"
			h={48}
			fz={16}
			fw={500}
		>
			Contact support
		</Button>
	),
};

export const TFErrorTemplate = ({ errorMessage, trackErrorFn }: TFErrorTemplateProps) => {
	const errorMessageProps = errorMessage ? { ...defaultErrorMessage, ...errorMessage } : defaultErrorMessage;

	useEffect(() => {
		if (trackErrorFn) {
			trackErrorFn();
		}
	}, [trackErrorFn]);

	return (
		<Center h="100vh" p="1rem">
			<TFCard
				sx={({ breakpoints }) => ({
					width: '100%',
					maxWidth: breakpoints.md,
				})}
			>
				<TFEmptyStateMessage isLarge={true} {...errorMessageProps} />
			</TFCard>
		</Center>
	);
};
